import React from "react";
import MainAppGenericModal from "../GenericModal";

import styles from "./Modals.GenericErrorModal.module.scss";
import i18n from "i18n";

export class GenericErrorModal extends React.Component {

  render() {
    const {
      open,
      handleClose,
      error,
      showErrorIcon = false,
    } = this.props;

    const content = (<div className={styles["error-category-modal-wrapper"]}>
      {showErrorIcon &&
        <div className={styles["icon-div"]}>
          <i className={`icon-error icon-iconos_alerta ${styles["icon-error"]}`}></i>
        </div>
      }
      <div className={styles["error-category-modal-text"]}>{error}</div>
      <div className={styles["error-category-modal-buttons"]}>
        <div className={styles["error-category-modal-button"]} onClick={handleClose} data-automation-id="confirm">{i18n.t("understood").toUpperCase()}</div>
      </div>
    </div>)
    return (
      <div className={styles["error-category-modal-container"]}>
          <MainAppGenericModal open={open} content={content} handleClose={handleClose}></MainAppGenericModal>
      </div>
    );
  }
}

GenericErrorModal.propTypes = {
};

export default GenericErrorModal;
